import { Link } from 'react-router-dom';
import type { Figure } from '@/types/content';

export default function FigureCard({ figure }: { figure: Figure }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <div className="relative h-64 w-full overflow-hidden bg-background-200 md:h-72">
        <img
          src={figure.cover}
          alt={`${figure.name} 档案照片，${figure.field}领域人物记录`}
          title={`${figure.name} · 档案人物库`}
          className="h-full w-full object-top object-cover"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-[11px] font-medium tracking-wider text-foreground-800">
          {figure.alias}
        </span>
        <span className="absolute right-3 top-3 flex h-7 items-center gap-1 rounded-full bg-accent-500 px-3 text-[11px] font-medium text-background-50">
          <i className="ri-fire-line" aria-hidden="true"></i>
          {figure.heat}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-center gap-2">
          <h3 className="font-heading text-lg font-bold text-foreground-950">{figure.name}</h3>
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
            {figure.field}
          </span>
        </div>
        <p className="mt-1 text-xs tracking-wide text-foreground-500">
          {figure.region} · {figure.era}
        </p>
        <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">
          {figure.summary}
        </p>

        <div className="mt-4 flex flex-wrap gap-2">
          {figure.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600"
            >
              #{tag}
            </span>
          ))}
        </div>

        <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
          <span className="text-xs text-foreground-500">
            关联记录 <strong className="text-foreground-900">{figure.recordCount}</strong> 条
          </span>
          <Link
            to={`/topics?figure=${figure.id}`}
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-900"
          >
            查看相关专题
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}